import { useEffect } from 'react'
import { useLazyQuery } from '@apollo/client'
import UserContentImage from 'components/UserContentImage'
import REFRESH_PRODUCT_PICTURE from './graphql/RefreshProductPicture.graphql'
import { RefreshProductPicture, RefreshProductPictureVariables } from './graphql/__generated__/RefreshProductPicture'

type ProductImageProps = {
  iconSize?: number
  shouldRefresh?: boolean
  photoUrl?: string
  catalogId?: string
  productId?: string
}

const ProductImage = ({ iconSize, shouldRefresh, photoUrl, catalogId, productId }: ProductImageProps) => {
  const [refreshProductPicture, { data }] = useLazyQuery<RefreshProductPicture, RefreshProductPictureVariables>(
    REFRESH_PRODUCT_PICTURE
  )

  useEffect(() => {
    if (shouldRefresh && catalogId && productId) {
      refreshProductPicture({ variables: { catalogId, productId } })
    }
  }, [refreshProductPicture, shouldRefresh, catalogId, productId])

  const photoSrc = data?.currentSeller?.catalog?.draftProduct?.pictures?.nodes?.[0]?.gridPhotoUrl ?? photoUrl

  return <UserContentImage src={photoSrc} iconSize={iconSize ?? 18} />
}

export default ProductImage
